

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import NavLinks from '../NavLinks';
import PresetButtons from '../PresetButtons';
import MiniSlider from '../WaterSliderMini/WaterSliderMini';
import styles from './Menu.css';
import withStyles from '../../decorators/withStyles';


class Menu extends Component {

  static propTypes = {
    menuOpen: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <section className={"Menu " + (this.props.menuOpen ? "open" : "")}>
        <NavLinks>
          <div className="nav-btn controls">
            <span className="nowrap">
            <MiniSlider horizontal={true} />
            </span>
          </div>
        </NavLinks>
      </section>
    );
  };

}

export default withStyles(styles)(Menu);
